var React = require('react');

function HoursInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8 16A8 8 0 1 1 8 0a8 8 0 0 1 0 16zM7 7H4v2h4a1 1 0 0 0 1-1V2H7v5z","fill":"currentColor","fillRule":"evenodd"}));
}

HoursInline.defaultProps = {"viewBox":"0 0 16 16"};

module.exports = HoursInline;

HoursInline.default = HoursInline;
